import React, { useState } from 'react'
import { Button, Text } from '@pandiafi/design-system'
import { ContextNotification, Modal, Icon } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import { useAppVersionCheck } from 'hooks/useAppVersionCheck/useAppVersionCheck'

export const AppVersionBanner: React.FC = () => {
  const { t } = useTranslation(['common'])
  const { isOutdated } = useAppVersionCheck()
  const [dismissed, setDismissed] = useState(false)

  const reload = () => window.location.reload()

  if (!isOutdated) {
    return null
  }

  if (dismissed) {
    return (
      <div className="relative z-[60]">
        <ContextNotification
          icon="info-circle"
          type="warning"
          action={
            <Button small variant="secondary" onClick={reload}>
              {t('common:reloadPage')}
            </Button>
          }
        >
          <div className="mx-auto">{t('common:newVersionAvailable')}</div>
        </ContextNotification>
      </div>
    )
  }

  return (
    <Modal
      show
      onClose={() => setDismissed(true)}
      title={t('common:newVersionTitle')}
    >
      <Modal.Content>
        <div className="text-center">
          <Icon icon="info-circle" size="l" className="mb-3 text-brand-6" />
          <Text element="p">{t('common:newVersionAvailable')}</Text>
        </div>
      </Modal.Content>
      <Modal.Buttons layout="centered">
        <Button variant="secondary" onClick={() => setDismissed(true)}>
          {t('common:closeWindow')}
        </Button>
        <Button variant="secondary" onClick={reload}>
          {t('common:reloadPage')}
        </Button>
      </Modal.Buttons>
    </Modal>
  )
}
